//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Breadcrumbs } from '~/plugins/breadcrumbs'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import FaqItems from '~/components/Flotillas/FaqItems'

export default {
  name: 'how-it-works.vue',
  mixins: [pageMeta],
  components: {
    FaqItems
  },
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      await mxGetMeta(ctx, {
        meta: {
          method: 'static',
          breadcrumbs: true
        }
      })
      const crubms = Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [{
        title: ctx.app.i18n.t('how-it-works'),
        url: ctx.route.fullPath
      }])
      await ctx.store.dispatch('setBreadcrumbs', crubms)
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      faq: {
        items: [
          {
            question: this.$t('can-i-see-a-booking-as-co'),
            answer: this.$t('to-book-a-trip-can-be-exc')
          },
          {
            question: this.$t('can-i-cancel-my-booking-'),
            answer: this.$t('yes-you-can-cancel-your')
          },
          {
            question: this.$t('how-do-i-contact-the-boat'),
            answer: this.$t('to-contact-the-boat-owner')
          },
          {
            question: this.$t('how-do-i-know-if-there-ar'),
            answer: this.$t('on-the-booking-page-you-c')
          },
          {
            question: this.$t('how-do-i-pay-for-my-booki'),
            answer: this.$t('to-pay-for-your-confirmed')
          },
          {
            question: this.$t('why-can-i-not-call-or-ema'),
            answer: this.$t('to-guarantee-your-safety')
          },
        ]
      }
    }
  }
}
